<template>
  <div class="cg-loader">
    <img :src="loaderUrl" alt="" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CgLoader',
  props: {
    /**
     * Sets the loader to be black.
     */
    black: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Sets the loader to be white.
     */
    white: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    loaderUrl (): string {
      const { black, white } = this;

      if (black) { return 'https://cf.corporategift.com/images/loader/black-loader.gif' }
      if (white) { return 'https://cf.corporategift.com/images/loader/white-loader.gif' }

      return 'https://cf.corporategift.com/images/loader/black-loader.gif'
    }
  },
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
